import React, { useState, useEffect } from "react";
import {
  Pagination,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Checkbox,
  Button
} from "@mui/material";
import { Search, Email, Person } from "@mui/icons-material";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import MKBox from "components/MKBox";
import SideNav from "components/Navbars/DefaultNavbar/Sidenav";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { adminRoutes } from "routes";
import AdminApis from "apis/AdminApis";
import { useError } from "hooks/ErrorContext";
import { useSuccess } from "hooks/SuccessContext";

const CCPanelUsers = () => {
  const { showError } = useError();
  const { showMessage } = useSuccess();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await AdminApis.getUnverifiedUsers();
        const mockUsers = response?.data?.data || [];
        setUsers(mockUsers);
        setFilteredUsers(mockUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = users.filter(
      (user) =>
        user.first_name.toLowerCase().includes(value) ||
        user.last_name.toLowerCase().includes(value) ||
        user.email.toLowerCase().includes(value)
    );
    setFilteredUsers(filtered);
    setCurrentPage(1);
  };

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedUsers(currentUsers.map((user) => user.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectUser = (userId) => {
    setSelectedUsers((prevSelected) =>
      prevSelected.includes(userId)
        ? prevSelected.filter((id) => id !== userId)
        : [...prevSelected, userId]
    );
  };

  const isSelected = (userId) => selectedUsers.includes(userId);

  const verifyUsers = async () => {
    const selectedUserIds = selectedUsers;
    await AdminApis.verifyUsers({ userIds: selectedUserIds })
      .then((response) => {
        showMessage("Users verified successfully")

        console.log("Users verified successfully:", response.data);
      })
      .catch((error) => {
        showError("Error verifying users:", error);
      });

  }

  const sideNavItems = [
    { text: "Home", icon: <HomeIcon /> },
    { text: "About", icon: <InfoIcon /> },
    { text: "Contact", icon: <ContactMailIcon /> },
  ];

  return (
    <div className="min-h-screen bg-red-900">
      <DefaultNavbar routes={adminRoutes} sticky />
      <MKBox className="flex flex-col items-center justify-center min-h-screen">
        <div className="w-4/5 flex">
          <div className="w-1/4">
            <SideNav sideNavItems={sideNavItems} />
          </div>
          <div className="w-3/4 p-6 bg-white rounded-lg shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <Typography variant="h5">
                <Person className="align-middle mr-2" />
                Unverified Users
              </Typography>
              <Button variant="contained" style={{ color: "#fff" }} onClick={() => verifyUsers()}>
                Verify Users
              </Button>
            </div>
            <TextField
              label="Search by name or email"
              variant="outlined"
              fullWidth
              value={searchTerm}
              onChange={handleSearch}
              className="mb-6"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
            <div className="overflow-x-auto mt-2">
              <table className="w-full table-auto border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 p-2">
                      <Checkbox
                        indeterminate={
                          selectedUsers.length > 0 && selectedUsers.length < currentUsers.length
                        }
                        checked={selectedUsers.length === currentUsers.length}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="border border-gray-300 p-2">Class Number</th>
                    <th className="border border-gray-300 p-2">Name</th>
                    <th className="border border-gray-300 p-2">Email</th>
                    <th className="border border-gray-300 p-2">Occupation</th>
                    <th className="border border-gray-300 p-2">Address</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.length > 0 ? (
                    currentUsers.map((user) => (
                      <tr key={user.id} className="hover:bg-gray-100">
                        <td className="border border-gray-300 p-2">
                          <Checkbox
                            checked={isSelected(user.id)}
                            onChange={() => handleSelectUser(user.id)}
                          />
                        </td>
                        <td className="border border-gray-300 p-2">{user.school_num}</td>
                        <td className="border border-gray-300 p-2">{user.first_name} {user.last_name}</td>
                        <td className="border border-gray-300 p-2">{user.email}</td>
                        <td className="border border-gray-300 p-2">{user.occupation}</td>
                        <td className="border border-gray-300 p-2">{user.address}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="border border-gray-300 p-2 text-center">
                        No users found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="mt-6 flex justify-center">
              <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} color="primary" />
            </div>
          </div>
        </div>
      </MKBox>
    </div>
  );
};

export default CCPanelUsers;
